export default "__VITE_ASSET__BNnwGYcS__"